/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enable_NowInputs */

const en_enable_now = /** @type {(inputs: Enable_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable Now`)
};

const es_enable_now = /** @type {(inputs: Enable_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar ahora`)
};

const fr_enable_now = /** @type {(inputs: Enable_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer maintenant`)
};

const de_enable_now = /** @type {(inputs: Enable_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt aktivieren`)
};

const ja_enable_now = /** @type {(inputs: Enable_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐ有効にする`)
};

const zh_enable_now = /** @type {(inputs: Enable_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即启用`)
};

const ar_enable_now = /** @type {(inputs: Enable_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفعيل الآن`)
};

const id_enable_now = /** @type {(inputs: Enable_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktifkan Sekarang`)
};

const it_enable_now = /** @type {(inputs: Enable_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita Ora`)
};

const ru_enable_now = /** @type {(inputs: Enable_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить сейчас`)
};

const pt_enable_now = /** @type {(inputs: Enable_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar Agora`)
};

const ko_enable_now = /** @type {(inputs: Enable_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지금 활성화`)
};

/**
* | output |
* | --- |
* | "Enable Now" |
*
* @param {Enable_NowInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const enable_now = /** @type {((inputs?: Enable_NowInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enable_NowInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enable_now(inputs)
	if (locale === "es") return es_enable_now(inputs)
	if (locale === "fr") return fr_enable_now(inputs)
	if (locale === "de") return de_enable_now(inputs)
	if (locale === "ja") return ja_enable_now(inputs)
	if (locale === "zh") return zh_enable_now(inputs)
	if (locale === "ar") return ar_enable_now(inputs)
	if (locale === "id") return id_enable_now(inputs)
	if (locale === "it") return it_enable_now(inputs)
	if (locale === "ru") return ru_enable_now(inputs)
	if (locale === "pt") return pt_enable_now(inputs)
	return ko_enable_now(inputs)
});